import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { ConfluencePages, UserRole } from '../enums'
import { UserManualProvider } from '../contexts/userManual'
import Redirect from '../pages/Redirect'
import LoadingState from '../components/LoadingState'

const Users = lazy(() => import('../pages/pages/Users'))
const User = lazy(() => import('../pages/pages/Profile'))

export default [
  {
    path: '/users',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN]}>
        <UserManualProvider pageId={ConfluencePages.USERS}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <Users />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/users/:id',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.INSTALLER,
          UserRole.GUEST
        ]}
      >
        <UserManualProvider pageId={ConfluencePages.USERS}>
          <DashboardLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <User />
            </Suspense>
          </DashboardLayout>
        </UserManualProvider>
      </AuthGuard>
    )
  },
  {
    path: '/profile/:id',
    element: <Redirect to="/users/:id" />
  }
]
